export enum RequisitesStatus {
  Active = 'active',
  Inactive = 'inactive',
  Blocked = 'blocked',
}
